import styled from 'styled-components'

export default styled.div`
  display: flex;
  align-items: center;

  &.checkbox {
    display: inline-flex;
    align-items: center;
    padding: 0.1rem;
    margin-bottom: 0.5rem;
    cursor: pointer;

    .checkbox-border {
      position: relative;
      border: 2px solid ${(props) => props.theme.palette.gray[100]};
      border-radius: 0.4rem;
      margin-right: 0.8rem;
      width: 2.4rem;
      height: 2.4rem;

      .checkbox-border-indicator {
        position: absolute;
        background-color: #20a0ff;
        margin: 0.2rem;
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 0.2rem;
        transform: scale(0);
        transition: transform 100ms;

        &.checked {
          transform: scale(1);
        }
      }
    }

    .checkbox-label {
      position: relative;
      top: 0.2rem;
      font-size: 1.4rem;

      &.parent {
        font-weight: bold;
        font-size: 1.6rem;
      }
    }

    &:hover {
      .checkbox-border {
        border-color: ${(props) => props.theme.palette.gray[200]};
      }
    }
  }

  .menu-info-icon {
    margin-top: 0.5rem;
    svg {
      width: 2rem;
      height: 2rem;
      color: ${(props) => props.theme.palette.gray[200]};
    }
  }
`
